import { classNames } from '~/utils';

interface LoadingSpinnerProps {
  width?: number;
  height?: number;
  className?: string;
  wrapperClassName?: string;
}

export function LoadingSpinner({ width = 50, height = 50, className, wrapperClassName }: LoadingSpinnerProps) {
  return (
    <div
      className={classNames('flex h-full items-center justify-center', wrapperClassName)}
      data-testid="loading-spinner"
    >
      <svg
        aria-label="loading"
        className={classNames('mr-3 -ml-1 animate-spin text-teal-700', className)}
        fill="none"
        height={height}
        role="img"
        viewBox="0 0 24 24"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>loading</title>
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path
          className="opacity-75"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
